import { DEFAULT_USER_STRATEGY_SETTINGS } from "src/components";
import { useSettings, type IUserStrategySettings } from "src/hooks";

const useUserStrategySettings = (userGuid: string) => {
  const {
    userStrategySettings: { [userGuid]: unsafeSettings },
    updateUserStrategySettings,
  } = useSettings();

  const safeSettings: IUserStrategySettings = {
    ...DEFAULT_USER_STRATEGY_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IUserStrategySettings>) => {
      updateUserStrategySettings(userGuid, updatedSettings);
    },
  };
};

export { useUserStrategySettings };
